import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

const root = document.getElementById("root");

const script = document.createElement("script");
// script.crossOrigin = "anonymous";
script.src = "https://cdn.jsdelivr.net/npm/rhino3dm@7.14.0/rhino3dm.min.js";
script.addEventListener("load", () => {
  window.rhino3dm().then((Module) => {
    window.rhino = Module;
    ReactDOM.render(<App />, root);
  });
});

const fetchJsFromCDN = (src, key) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.addEventListener("load", () => {
      resolve(window[key]);
    });
    script.addEventListener("error", reject);
    document.body.appendChild(script);
  });
};

async function setCompute() {
  var compute = await fetchJsFromCDN(
    "https://files.mcneel.com/rhino3dm/js/latest/compute.rhino3d.js",
    ["RhinoCompute"]
  );
  compute.authToken = compute.getAuthToken();
  window.compute = compute;
}

//setCompute();

document.body.append(script);
